import ConfigAI from '../configs/ConfigAI';
import Cookies from "js-cookie";
import ConfigCmsApi from "@/api/configs/ConfigCmsApi";

const parseClinic = (data) => ConfigAI.post('/clinic-parser-playground/', data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const saveTextTemplate = (data) => ConfigAI.post('https://ai.bookimed.com/text-generations/save-template', data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const updateTextTemplate = (data) => ConfigAI.put('https://ai.bookimed.com/text-generations/update-template', data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const deleteTextTemplate = (data) => ConfigAI.request({
  data,
  url: 'https://ai.bookimed.com/text-generations/delete-template',
  method: 'delete',
  headers: {
    Authorization: Cookies.get('userToken'),
    'Content-Type': 'application/json',
  },
});

const getTextTemplates = (data) => ConfigAI.post('https://ai.bookimed.com/text-generations/get-templates', data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const generateText = (data) => ConfigAI.post('https://ai.bookimed.com/text-generations/queue-request', data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getRequestResult = (params) => ConfigCmsApi.get('https://ai.bookimed.com/text-generations/get-request-result', {
  params,
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

export default {
  parseClinic,
  saveTextTemplate,
  updateTextTemplate,
  getTextTemplates,
  deleteTextTemplate,
  generateText,
  getRequestResult,
};
